<template>
  <div v-show="question" class="plv-ia-answer-main__right__wrap">
    <question-edit-normal
      v-if="question.itemType === 0"
      :question="question"
      :channel-setting="channelSetting"
      @save="save"
      @cancel="cancel"
    />

    <question-edit-quick
      v-else
      :channel-setting="channelSetting"
      @send="send"
    />
  </div>
</template>

<script>
import QuestionEditQuick from './QuestionEditQuick';
import QuestionEditNormal from './QuestionEditNormal';

export default {
  components: {
    QuestionEditQuick,
    QuestionEditNormal,
  },

  props: {
    question: {
      type: Object,
      default: null,
    },

    channelSetting: {
      type: Object,
      default: null,
    },
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    save(data) {
      this.$emit('save', data);
    },

    send(data) {
      this.$emit('send', data);
    },
  }
};
</script>

<style lang="scss">
.plv-ia-answer-question-edit {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 24px;
  color: #333;
  padding-bottom: 80px;
  padding-right: 4px;
}

.plv-ia-answer-question-edit__top {
  height: 100%;
  overflow: auto;
}

.plv-ia-answer-question-edit__bottom {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 24px;
  box-sizing: border-box;
}

.plv-ia-answer-question-edit__section + .plv-ia-answer-question-edit__section {
  margin-top: 20px;
}

.plv-ia-answer-question-edit__label {
  float: left;
  margin-right: 8px;
  line-height: 1;
}

.plv-ia-answer-question-edit__content {
  float: left;
  line-height: 1;
}
</style>
